/*
 *  Copyright 2017 Adobe Systems Incorporated. All rights reserved.
 *  This file is licensed to you under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License. You may obtain a copy
 *  of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 *  Unless required by applicable law or agreed to in writing, software distributed under
 *  the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 *  OF ANY KIND, either express or implied. See the License for the specific language
 *  governing permissions and limitations under the License.
 *
 */

import InstallationScss from './Installation.scss';
import AppsUtil from '../../../utils/AppsUtil';
import CSSUtil from '../../../utils/CSSUtil';
import Close from '@react/react-spectrum/Icon/Close';
import React, {Component} from 'react';
import Dialog from '@react/react-spectrum/Dialog';
import EmailMeLink from './EmailMeLink';
import {additionalDownloadMessageData} from '../../../constants/appsConstants';
import Kaizen from '../../CCD/DownloadScreen/Kaizen/Kaizen';
import Thor from '../../CCD/DownloadScreen/Thor/Thor';
import DownloadOnMobile from '../../DownloadOnMobile/DownloadOnMobile';

export default class Installation extends Component {
	constructor(props) {
		super(props);
		this.data = props.data;
		this.pdpType = props.pdpType;
		this.thorPresent = props.thorPresent;
		this.onAppDetailEvent = props.onAppDetailEvent;
		this.genericPDPAnalyticEvent = props.genericPDPAnalyticEvent;
		this.productSapCode = props.productSapCode;
		this.productName = props.productName;
		this.useCreativeCloudInstallerName = '';
		this.setAlertModalGoBackClicked = props.setAlertModalGoBackClicked;
		this.alertModalGoBackClicked = false;
	}

	applyWrapperClass() {
		const dialogNode = document.querySelector('.PDPDialogContent.spectrum-Dialog');
		if (dialogNode) {
			CSSUtil.addClass(dialogNode.parentNode,'dialogWrapper');
			if (AppsUtil.isMobileOrTab()) {
				CSSUtil.addClass(dialogNode.parentNode,'mobileOrTab');
			}
		}
		if (this.thorPresent !== true || this.thorPresent) {
			CSSUtil.applyKaizenDownloadStarterClass(this.thorPresent);
		}
		CSSUtil.updateClass('.PDPDialogContent.spectrum-Dialog', 'alignCCDDesign');
	}

	checkHeight() {
		const dialogContent = document.getElementsByClassName('InstallationDialogContent')[0];
		if (dialogContent) {
			dialogContent.style.height = '100%';
			dialogContent.style.margin = '0rem';
		}
	}

	componentDidMount() {
		document.getElementsByTagName('body')[0].style.overflow = 'hidden';
		this.applyWrapperClass();
		this.checkHeight();
		if (this.thorPresent !== true || this.thorPresent) {
			this.genericPDPAnalyticEvent();
		}

		document.body.addEventListener('keydown', this.escapeHandler);
	}

	componentWillUnmount() {
		document.getElementsByTagName('body')[0].style.overflow = '';
		CSSUtil.applyKaizenDownloadStarterClass(this.thorPresent,true);
		CSSUtil.updateClass('.PDPDialogContent.spectrum-Dialog', 'alignCCDDesign', true);
		this.checkHeight();
		CSSUtil.hideInstallerPopUp(0);
		document.body.removeEventListener('keydown', this.escapeHandler);
	}

	escapeHandler(e) {
		const InstallationDialog = document.querySelector('.InstallationDialogContent');
		if (((e.keyCode && e.keyCode === 27) || typeof e.keyCode === 'undefined') && InstallationDialog) {
			e.stopPropagation();
		}
	}

	getWorkflow() {
		if (this.thorPresent === true && this.productSapCode !== 'KCCC') {
			return 'thor';
		}
		return 'kaizen';
	}

	renderEmailMeLink(closeDialog) {
		if (AppsUtil.isIPad()
			&& (AppsUtil.isPhotoshopPostPurchase() || (
				AppsUtil.isPostPurchaseUser() && AppsUtil.getCCWebPathData().product === 'illustrator'
			))
		) {
			return <DownloadOnMobile process='cchome' formatMessage={this.props.intl.formatMessage} closeDialog={closeDialog}
				closePDP={this.props.closePDPDialog} locale={AppsUtil.locale} environment={this.props.environment} appId={this.props.productId} onAppDetailEvent={this.props.onAppDetailEvent}/>;
		}
		return (<EmailMeLink key='emailMeLink' onAppDetailEvent={this.onAppDetailEvent.bind(this)} productIconUrl={this.props.productIconUrl} productName={this.props.productName} appId={this.props.productId}
			closeDialog={closeDialog} formatMessage={this.props.formatMessage} closePDP={this.props.closePDPDialog}/>);
	}

	get showEmailMeLink() {
		return this.props.platform === 'desktop' && AppsUtil.isMobileOrTab();
	}

	renderInstall() {
		const productDetails = {
			id : this.props.productId,
			name : this.props.productName,
			sapCode : this.props.productSapCode
		};
		switch (this.getWorkflow()) {
			case 'thor':
				return (
					<Thor
						{...this.props} isCCH={true} intl={this.props.intl}
						genericPDPAnalyticEvent={this.genericPDPAnalyticEvent} product={productDetails} locale={this.props.locale}
						isFullPage={this.props.isFullPage} formatMessage={this.props.formatMessage}
					/>
				);
			case 'kaizen':
				return (
					<Kaizen
						{...this.props} isCCH={true} intl={this.props.intl} locale={this.props.locale}
						product={productDetails} formatMessage={this.props.formatMessage}
						isFullPage={this.props.isFullPage} genericPDPAnalyticEvent={this.genericPDPAnalyticEvent}
						loadHomePage={this.props.loadHomePage}
					/>
				);
		}
	}

	render() {
		const InstallArr = [];
		let InstallationWrapperClassName = 'installationWrapperNew';
		if (additionalDownloadMessageData[this.productSapCode] !== undefined) {
			InstallationWrapperClassName += ' additionalDownload';
		}
		InstallArr.push(
			<Dialog key='dialogInstallation' id='InstallationDialog' ref='InstallationDialogContent' className='PDPDialogContent installationNew installation InstallationDialogContent'>
				{this.showEmailMeLink
					? (<div id='appsInstallationWrapper' className={this.props.PDPCSSClassNames.appsPDPWrapper}> {this.renderEmailMeLink(this.props.closeInstallationDialog.bind(this))} </div>)
					: (<div id='appsInstallationWrapperNew' className={this.props.PDPCSSClassNames.appsPDPWrapper}>
						<div className={this.props.PDPCSSClassNames.header}>
							<div className={this.props.PDPCSSClassNames.toolBar}>
								{(this.thorPresent !== true || this.thorPresent) && (
									<div tabIndex={0} role='button' aria-label='Close'
										className={`${this.props.PDPCSSClassNames.closeContainer} ${InstallationScss.closeContainer} closeContainer`}
										onKeyDown={(e) => {
											if (e.key === 'Enter') {
												this.onAppDetailEvent('click', 'close');
												this.props.closeInstallationDialog();
											}
										}}
									>
										<Close className={`closeIcon ${this.props.PDPCSSClassNames.closeIcon}`} size='S'
											onClick={() => {
												this.onAppDetailEvent('click', 'close');
												this.props.closeInstallationDialog();
												this.props.executeCommand();
											}}
										/>
									</div>)}
							</div>
						</div>
						<div key='installationWrapperNew' className = {InstallationWrapperClassName}>
							<div className={`${this.getWorkflow()} ${InstallationScss.installationContent} ${this.pdpType} ${InstallationScss.stepsContainer} ${this.data && AppsUtil.convertAEMToCCHClass(this.data.gridClassNames)}`} ref={(installationTab) => {this.installationTab = installationTab;}}>
								{this.renderInstall()}
							</div>
						</div>
					</div>)
				}
			</Dialog>
		);
		return (InstallArr);
	}
}
